import { Injectable } from '@angular/core';
import { ContentService } from '@citi-gcg-173875/citi-http';
import { mergeMap, of } from 'rxjs';
import { MktContentStorageService } from './mkt-content-storage.service';

@Injectable({
  providedIn: 'root'
})
export class MktAEMService {

  constructor(
    private _contentStorageService: MktContentStorageService,
    private _contentService: ContentService
  ) { }

  getPageContent(pageType = 'demo', category = "", variation = "") {
    if(!pageType) of(null);
    if(!!category && category.includes('all-cards')) pageType = 'family';
    const baseUrlMap = {
      'vac': 'marketing-cards/getvacpage%3Bpath=/content/dam/cfs/uspb/usmkt/cards/en/static/vac-page/view-all-cards-category',
      'explore': 'marketing-cards/getexplorepage%3Bpath=/content/dam/cfs/uspb/usmkt/cards/en/static/explore-page/card-conatiner-explore-page%3Bcid1=hp-dpo-prequal-offers',
      'mpp': `marketing-cards/getmppcardpage%3Bpath=/content/dam/cfs/uspb/usmkt/cards/en/static/category/${category}-cards/${category}-cards-category`,
      'Banner': `marketing-cards/getbanners%3Bpath=/content/dam/cfs/uspb/usmkt/cards/en/static%3Bcid=${category}`,
      'Engagement': `marketing-cards/getem_data%3Bpath=/content/dam/cfs/uspb/usmkt/cards/en/static%3Bcid=${category}`,
      'pdp': `marketing-cards/getpdpcardpage%3Bpath=/content/dam/cfs/uspb/usmkt/cards/en/static/pdp-page/${category}`,
      'family': `marketing-cards/getpdpfamilypage%3Bpath=/content/dam/cfs/uspb/usmkt/cards/en/static/family-pages/${category}`,
      'travel': `travel-microsite/luxury-hotel-collection%3Bpath=/content/dam/cfs/uspb/usmkt/microsites/travel-microsite/en/luxury-hotel-collection`,
      'default': 'marketing-cards/getVACDetails%3Bpath=/content/dam/content-fragments/marketing/cards/explore-cards'
    };
    let baseUrl = baseUrlMap[pageType];
    if(variation?.trim() !== "")  baseUrl += `%3Bvariation=${variation.toLowerCase()}`;
    return this._contentService.makeAEMContentCall(baseUrl).pipe(mergeMap(data => this.saveData(data, (["Engagement", "Banner"].includes(pageType) ? `${pageType}_${category}` : pageType))));
  }

  private saveData(response: any, appId: string) {
    let returnObj: any = {}
    if (response && response["data"]) {
      this._contentStorageService.set(appId, JSON.stringify(response["data"]));
      returnObj = this._contentStorageService.getByAppId(appId);
    }
    return of(returnObj);
  }
}
